module.exports = __webpack_public_path__ + "static/media/accessDenied.c09612c0.mp3";